import { styled } from '@slal/ui';

export const StyledCard = styled.div`
    padding: ${({ theme: { space } }) => space[5]};
    margin-bottom: ${({ theme: { space } }) => space[5]};
    border: 1px solid ${({ theme }) => theme.colors.neutral__light__60};
    border-radius: ${({ theme: { borderRadius } }) => borderRadius.large};
`;
